export enum ProcessEnum {
  processing = "proc",
  rejected = "rej",
  completed = "com",
  started = "started",
  candidateRejected = "crj",
  processRejected = "proc_rej",
}

export const ProcessEnumDisplayLabel: { [key: string]: string } = {
  //proc: "Processing",
  proc: "Registered",
  rej: "Rejected",
  com: "Completed",
  started: "Started",
  crj: "Candidate Rejected",
  created: "Created",
  proc_rej: "Process Rejected",
};

export enum ProcessCardEnum {
  processing = "proc",
  approved = "apr",
  rejected = "rej",
  completed = "com",
  candidateRejected = "crj",
  processRejected = "proc_rej",
}

export const ProcessCardEnumDisplayLabel: { [key: string]: string } = {
  proc: "Processing",
  apr: "Approved",
  rej: "Rejected",
  com: "Completed",
  crj: "Candidate Rejected",
  proc_rej: "Process Rejected",
};

export enum ProcessCardPassportEnum {
  notchanged = "proc",
  collected = "collect",
  returned = "return",
}

export const ProcessCardPassportEnumDisplayLabel: { [key: string]: string } = {
  collect: "Collected",
  return: "Returned",
  proc: "Not Changed",
};
export enum CountryProcessTemplateTypeEnum {
  textCard = "Text",
  photoPassportSize = "Photo",
  cv = "CV",
  pdf = "PDF"
}
export enum CountryProcessCardTypeEnum {
  offerLetterAcceptance = "ola",
  Medical = "med",
  Visa = "visa",
  SLBFV = "slbfv",
  AirTicket = "at",
  Training = "tr",
  PoliceReport = "polr",
  Passport = "passport"
}
export const CountryProcessDisplayLabelEnum: { [key: string]: string } = {
  ola: "Offer Letter Acceptance",
  med: "Medical Certificate",
  visa: "Visa",
  slbfv: "SLBFV",
  at: "Air Ticket",
  tr: "Training",
  polr: "Police Report",
  passport: "Passport"
}
export enum MedicalCenterEnum {
  KMED_KURUNEGALA = 1,
  GOLDMED_KURUNEGALA = 2,
  KURUNEGALA_DIAGNOSTIC_CENTER = 3,
  V_CARE_MEDICAL_KURUNEGALA = 4,
  LEAP_MEDICAL_KURUNEGALA = 5,
}
export const MedicalCenterDisplayEnum: { [key: string]: string } = {
  1: "KMED KURUNEGALA",
  2: "GOLDMED KURUNEGALA",
  3: "KURUNEGALA DIAGNOSTIC CENTER",
  4: "V CARE MEDICAL KURUNEGALA",
  5: "LEAP MEDICAL KURUNEGALA",
};
export enum CountryCodeEnum {
  Arab = "UAE",
  Qatar = "QATAR",
  Kuwait = "KUWAIT",
  Ksa = "KSA",
  Baharain = "BAHRAIN",
  Oman = "OMN",
  Jordan = "JORDAN",
  Lebanon = "LEBANON",
  Singapore = "SINGAPORE",
  Malaysia = "MALAYSIA",
  Cyprus = "CYPRUS",
  HongKong = "HONGKONG",
}
export const CountryCodeDisplayEnum: { [key: string]: string } = {
  UAE: "UAE",
  QATAR: "Qatar",
  KUWAIT: "Kuwait",
  KSA: "KSA",
  BAHRAIN: "Baharain",
  OMN: "Oman",
  JORDAN: "Jordan",
  LEBANON: "Lebanon",
  SINGAPORE: "Singapore",
  MALAYSIA: "Malaysia",
  CYPRUS: "Cyprus",
  HONGKONG: "Hong Kong",
};

export enum SkillLevelEnum {
  very_good = "VeryGood",
  good = "Good",
  not_good = "NotGood",
}

export const SkillLevelDisplayEnum: { [key: string]: string } = {
  VeryGood: "Can",
  Good: "Help Madam",
  NotGood: "Cannot",
};

export const SkillLevelPrevEnum: { [key: string]: string } = {
  very_good : "Can",
  good : "Help Madam",
  not_good : "Cannot",
}

export const AttachmentTagEnum: { [key: string]: string } = {
  profile_pic: "Profile Picture",
  full_pic: "Full Picture",
  interview_video: "Interview Video",
  other: "Other"
}

export const RecStatusDisplayEnum: { [key: number]: { label: string, color: "error" | "warning" | "success" | "info" | "default" } } = {
  0: { label: "Recruitment Pending", color: "info" },
  1: { label: "Pending", color: "warning" },
  2: { label: "Registered", color: "success" },
  3: { label: "Rejected (B)", color: "error" },
  4: { label: "Candidate Rejected", color: "error" },
  5: { label: "Process Rejected", color: "error" },
  6: { label: "Completed", color: "success" },
  7: { label: "Awaiting Passport", color: "info" },
}

export const pdfTypeEnum: { [key: string]: { label: string, color: string } } = {
  cook: { label: "Cooking", color: "#C65911" },
  exp: { label: "Experienced Housemaid", color: "#00B050" },
  non_exp: { label: "Non Experienced Housemaid", color: "#FF0066" },
  houseboy: { label: "Houseboy", color: "#CC0066" },
  caregiver: { label: "Caregiver", color: "#808000" },
  nurse: { label: "Nurse", color: "#66FFFF" },
  beautician: { label: "Beautician", color: "#CC0099" },
  tailor: { label: "Tailor", color: "#ED8513" },
  driver: { label: "Driver", color: "#0000FF" },
};
